export const TEXT_ORIENTATION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  VERTICAL_UP: "vertical-up",
};

export const resolveTextOrientation = (value) => {
  switch (String(value || "")) {
    case TEXT_ORIENTATION.VERTICAL:
      return TEXT_ORIENTATION.VERTICAL;
    case TEXT_ORIENTATION.VERTICAL_UP:
      return TEXT_ORIENTATION.VERTICAL_UP;
    case TEXT_ORIENTATION.HORIZONTAL:
    default:
      return TEXT_ORIENTATION.HORIZONTAL;
  }
};

export const isVerticalTextOrientation = (value) => {
  const orientation = resolveTextOrientation(value);
  return (
    orientation === TEXT_ORIENTATION.VERTICAL ||
    orientation === TEXT_ORIENTATION.VERTICAL_UP
  );
};

export const isVerticalUpTextOrientation = (value) =>
  resolveTextOrientation(value) === TEXT_ORIENTATION.VERTICAL_UP;

/** Top-to-bottom paint order. `vertical-up` draws the first glyph at the bottom. */
export const visualVerticalLineIndexes = (lineCount, orientation) => {
  const count = Math.max(0, Number(lineCount) || 0);
  const indexes = Array.from({ length: count }, (_, index) => index);
  return isVerticalUpTextOrientation(orientation) ? indexes.reverse() : indexes;
};
